import classNames from "classnames"
import React from "react"
import classes from "./AnimatedBar.module.css"

export interface AnimatedBarProps {
  start?: number
  startDelay: number
  updateDelay: number
  progress: number
  className?: string
  style?: React.CSSProperties
}

const AnimatedBar = ({
  progress,
  start,
  startDelay,
  updateDelay,
  className,
  style,
}: AnimatedBarProps) => {
  const [value, setValue] = React.useState(start ?? progress)
  const [initialized, setInitialized] = React.useState(false)

  React.useEffect(() => {
    const delay = initialized ? updateDelay : updateDelay + startDelay
    setInitialized(true)
    setTimeout(() => setValue(progress), delay)
  }, [progress])

  return (
    <div className={classNames(classes.root, className)} style={style}>
      <div
        className={classes.bar}
        style={{
          transform: `translateX(-${100 - value}%)`,
        }}
      ></div>
    </div>
  )
}

AnimatedBar.defaultProps = {
  start: 0,
  startDelay: 0,
  updateDelay: 400,
}

export default AnimatedBar
